import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetDealAppointments = async (DealId) => {
  /**
   * input: Deal ID
   * output: Appointments / collection
   * description: Get deal appointments / get documents
   */

  try {
    const AppointmentsCollection = collection(db, "appointments");
    const q = query(AppointmentsCollection, where("deal", "==", DealId));
    const AppointmentsSnapshot = await getDocs(q);
    const AppointmentsData = [];
    AppointmentsSnapshot.forEach((appointment) =>
      AppointmentsData.push({ id: appointment.id, ...appointment.data() })
    );

    return AppointmentsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetDealAppointments;
